<template>
  <SfModal
    v-if="modalOpen"
    content-class-name="sf-pad-3"
    size="xxs"
    @close="close"
  >
    <template #title>{{ I18n.t('reports.subnav.display_options') }}</template>

    <template #body>
      <div class="sf-below-2">
        <div class="sf-form-label">
          {{ I18n.t('reports.subnav.select_language') }}
        </div>
        <div class="sf-form-select-wrapper sf-full">
          <select
            v-model="currentLocale"
            class="sf-form-select"
            name="language"
          >
            <option
              v-for="locale in locales"
              :key="locale"
              :disabled="locale == currentLocale"
              :selected="locale == currentLocale"
              :value="locale"
            >
              {{ I18n.t(`js.languages.${locale}`) }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="currentShowAccountsAs" class="sf-below-2">
        <div class="sf-form-label">
          {{ I18n.t('reports.subnav.select_accounts_options') }}
        </div>
        <div class="sf-form-select-wrapper sf-full">
          <select
            v-model="currentShowAccountsAs"
            class="sf-form-select"
            name="showAccountsAs"
          >
            <option
              v-for="option in showAccountsAs"
              :key="option"
              :disabled="option == currentShowAccountsAs"
              :selected="option == currentShowAccountsAs"
              :value="option"
            >
              {{ I18n.t(`reports.subnav.show_${option}_accounts`) }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="currentShowAccountsAs !== undefined">
        <label class="sf-form-check sf-level"
          ><div class="sf-inline-block">
            <input
              v-model="currentShowAccountNumbers"
              :checked="currentShowAccountNumbers"
              type="checkbox"
            /><span class="sf-form-check-content"
              ><span class="sf-form-check-indicator"></span
            ></span>
          </div>
          <div>{{ I18n.t('reports.subnav.show_account_numbers') }}</div></label
        >
      </div>
    </template>

    <template #footer>
      <SfButtonDs variant="secondary" @click="close">{{
        I18n.t('reports.subnav.cancel')
      }}</SfButtonDs>
      <SfButtonDs variant="primary" @click="apply">{{
        I18n.t('reports.subnav.apply')
      }}</SfButtonDs>
    </template>
  </SfModal>
</template>

<script>
import { SfModal } from '@app/shared/vue/components/sf-modal'
import { SfButtonDs } from '@silverfin/ui-components'

import { setQueryParams } from '@app/utils/url-helpers'
import { getSafeJSONValue, setSafeJSONValue } from '@app/utils/local-storage'

import { REPORTS_SETTING_KEY } from '../constants'

export default {
  components: {
    SfModal,
    SfButtonDs,
  },

  data() {
    return {
      modalOpen: false,
      locales: [],
      currentLocale: null,
      showAccountsAs: ['original', 'mapped', 'mapped_and_original'],
      currentShowAccountsAs: null,
      currentShowAccountNumbers: null,
    }
  },

  methods: {
    openModal(context) {
      this.locales = context.locales
      this.currentLocale = context.currentLocale
      this.currentShowAccountsAs = context.currentShowAccountsAs
      this.currentShowAccountNumbers = context.currentShowAccountNumbers

      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    apply() {
      const settings = getSafeJSONValue(REPORTS_SETTING_KEY) || {}

      if (this.currentLocale) {
        settings.language = this.currentLocale
      }

      if (this.currentShowAccountsAs) {
        settings.show_accounts_as = this.currentShowAccountsAs
      }

      settings.show_account_numbers = this.currentShowAccountNumbers

      setSafeJSONValue(REPORTS_SETTING_KEY, settings)
      setQueryParams(settings)

      Turbolinks.visit(window.location.href)
    },
  },
}
</script>
